export default __webpack_public_path__ + "static/media/information--highway-interstate-route--g1.692a691b.png";